import {Grid} from "@mui/material";
import {CopyUtils} from "../../util/CopyUtils";
import {useTranslation} from "react-i18next";
import TextField from "../../common/form/TextField";
import {UserTranslKey} from "./UserTranslKey";
import {UserFilterDto} from "../../client/user/UserApiClient";

export interface UserFilterFormProps {
    filter: UserFilterDto;
    onChange: (filter: UserFilterDto) => void;
}

export function UserFilterForm(props: Readonly<UserFilterFormProps>) {
    const {filter, onChange} = props;

    const {t} = useTranslation();

    function onUserLoginChange(login: string) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.loginLike = normalizeString(login);
        onChange(updatedFilter);
    }

    function onUserFirstnameChange(userFirstname: string) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.firstNameLike = normalizeString(userFirstname);
        onChange(updatedFilter);
    }

    function onUserLastnameChange(userLastname: string) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.lastNameLike = normalizeString(userLastname);
        onChange(updatedFilter);
    }

    function onUserEmailChange(userEmail: string) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.emailLike = normalizeString(userEmail);
        onChange(updatedFilter);
    }

    function normalizeString(value: string): string | undefined {
        const normalizedValue = value.trim();
        return (normalizedValue.length > 0) ? normalizedValue : undefined;
    }

    return (
        <Grid container mt={0} spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
                <TextField label={t(UserTranslKey.LOGIN)}
                           value={filter.loginLike}
                           onChange={onUserLoginChange} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <TextField label={t(UserTranslKey.FIRST_NAME)}
                           value={filter.firstNameLike}
                           onChange={onUserFirstnameChange} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <TextField label={t(UserTranslKey.LAST_NAME)}
                           value={filter.lastNameLike}
                           onChange={onUserLastnameChange} />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <TextField label={t(UserTranslKey.EMAIL)}
                           value={filter.emailLike}
                           onChange={onUserEmailChange} />
            </Grid>
        </Grid>
    );
}
